const RankTypes = {
  FETCH_START:    '[MUSIC][RANK] FETCH START',
  FETCH_SUCCESS:  '[MUSIC][RANK] FETCH SUCCESS',
  FETCH_FAILURE:  '[MUSIC][RANK] FETCH FAILURE'
};

export default RankTypes;